import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';

import MSG from './sites/msg'

import './css/app.css'


export default function App() {
  return (
    <Switch>
      <Route exact path="/" component={MSG} />
      <Route render={() => <Redirect to="/" />} />
    </Switch>
  );
}
